module.exports = __webpack_public_path__ + "img/hugol.b4b0c249.jpeg";